// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__22KXI","additionalInfo":"AgreementModal_additionalInfo__24MvR"};